module.exports = __webpack_public_path__ + "static/banner-f5d4bea4442fd4765d2997fb9b60fe15.svg";